export type BuyFeatureStickTo = 'left' | 'right';

export type BuyFeatureConfig = {
    button?: {
        desktop?: {
            position?: {x?: number; y?: number;};
        };
        landscape?: {
            position?: {x?: number; y?: number;};
            stickTo?: BuyFeatureStickTo;
        };
        portrait?: {
            position?: {x?: number; y?: number;};
            stickTo?: BuyFeatureStickTo;
        };
    };
    featureNameTranslationKey: string;
    RTP: number;
};